
      var _path, _path2, _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCreditCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 121,
  height: 120,
  viewBox: "0 0 121 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 43h89v12h-89V43z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M71.5 77h22",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 31,
  width: 88,
  height: 58,
  rx: 6,
  stroke: "#000",
  strokeWidth: 4.4
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 10.5,
  y: 64,
  width: 38,
  height: 38,
  rx: 19,
  fill: "#fff"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 10.5,
  y: 64,
  width: 38,
  height: 38,
  rx: 19,
  stroke: "#000",
  strokeWidth: 4.4
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#credit_card_22c5d79edfffef8b__a)",
  fill: "var(--theme-primary, #810ea9)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.464 91.59c.848.368 1.837.048 2.2-.775l-.092-.04.091.04-2.199.775zm0 0-.008-.004m.008.004-.008-.004m0 0-.136-.075m.136.075-.137-.075m0 0-.01-.007m.01.007-.01-.007m0 0-.06-.043-4.791-2.068c-.848-.369-1.283-1.31-.927-2.117.319-.719 1.14-1.053 1.915-.853l.007.002.245.082.008.003 1.137.495m2.467 4.5-2.467-4.5m0 0-.02-.04v-.002c-1.119-2.488-1.236-5.247-.248-7.694 1.467-3.632 5.019-5.997 9.25-6.18.259-.012.518.034.757.13.58.235 1.007.749 1.084 1.354.115.898-.573 1.652-1.502 1.691-2.965.13-5.423 1.772-6.435 4.276l-.15.412c-.535 1.647-.375 3.473.429 5.12l.017.034.514-1.161.091.04m-3.787 2.02 5.83-2.733-.245-.083c-.736-.19-1.504.13-1.798.796m0 0-.546 1.235.546-1.235zm6.937-10.4c-.072-.565-.472-1.05-1.022-1.273a1.706 1.706 0 0 0-.715-.123c-4.197.182-7.712 2.525-9.162 6.117-.977 2.42-.862 5.15.246 7.616l10.653-12.337zm0 0c.107.835-.531 1.543-1.407 1.58l1.407-1.58zm-3.912 11.72-.091-.04.091.04zm9.32-6.413.018.034c.803 1.648.963 3.473.428 5.12l-.15.412c-1.012 2.505-3.47 4.148-6.436 4.277-.928.04-1.616.794-1.502 1.691l.1-.012c.103.815.88 1.433 1.736 1.398l5.806-12.92zm0 0-.512 1.162c-.359.809-1.362 1.139-2.206.752l2.718-1.914z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "credit_card_22c5d79edfffef8b__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "scale(1 -1) rotate(-21.984 -227.943 -74.4)",
  d: "M0 0h28v28H0z"
})))));

      const __svgRaw = "<svg width=\"121\" height=\"120\" viewBox=\"0 0 121 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M17.5 43h89v12h-89V43z\" fill=\"#000\"/>\r\n    <path d=\"M71.5 77h22\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <rect x=\"17.5\" y=\"31\" width=\"88\" height=\"58\" rx=\"6\" stroke=\"#000\" stroke-width=\"4.4\"/>\r\n    <rect x=\"10.5\" y=\"64\" width=\"38\" height=\"38\" rx=\"19\" fill=\"#fff\"/>\r\n    <rect x=\"10.5\" y=\"64\" width=\"38\" height=\"38\" rx=\"19\" stroke=\"#000\" stroke-width=\"4.4\"/>\r\n    <g clip-path=\"url(#yd8zlfk6xa)\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\".2\">\r\n        <path d=\"M22.464 91.59c.848.368 1.837.048 2.2-.775l-.092-.04.091.04-2.199.775zm0 0-.008-.004m.008.004-.008-.004m0 0-.136-.075m.136.075-.137-.075m0 0-.01-.007m.01.007-.01-.007m0 0-.06-.043-4.791-2.068c-.848-.369-1.283-1.31-.927-2.117.319-.719 1.14-1.053 1.915-.853l.007.002.245.082.008.003 1.137.495m2.467 4.5-2.467-4.5m0 0-.02-.04v-.002c-1.119-2.488-1.236-5.247-.248-7.694 1.467-3.632 5.019-5.997 9.25-6.18.259-.012.518.034.757.13.58.235 1.007.749 1.084 1.354.115.898-.573 1.652-1.502 1.691-2.965.13-5.423 1.772-6.435 4.276l-.15.412c-.535 1.647-.375 3.473.429 5.12l.017.034.514-1.161.091.04m-3.787 2.02 5.83-2.733-.245-.083c-.736-.19-1.504.13-1.798.796m0 0-.546 1.235.546-1.235zm6.937-10.4c-.072-.565-.472-1.05-1.022-1.273a1.706 1.706 0 0 0-.715-.123c-4.197.182-7.712 2.525-9.162 6.117-.977 2.42-.862 5.15.246 7.616l10.653-12.337zm0 0c.107.835-.531 1.543-1.407 1.58l1.407-1.58zm-3.912 11.72-.091-.04.091.04zM35.975 79.892l.018.034c.803 1.648.963 3.473.428 5.12l-.15.412c-1.012 2.505-3.47 4.148-6.436 4.277-.928.04-1.616.794-1.502 1.691l.1-.012c.103.815.88 1.433 1.736 1.398l5.806-12.92zm0 0-.512 1.162c-.359.809-1.362 1.139-2.206.752l2.718-1.914z\"/>\r\n    </g>\r\n    <defs>\r\n        <clipPath id=\"yd8zlfk6xa\">\r\n            <path fill=\"#fff\" transform=\"scale(1 -1) rotate(-21.984 -227.943 -74.4)\" d=\"M0 0h28v28H0z\"/>\r\n        </clipPath>\r\n    </defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/credit_card.22c5d79edfffef8b15b36ba39f019ed0.svg"),
        {
          React: SvgCreditCard,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      